import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ReceiveStatusProps {
  received: boolean;
}

export const ReceiveStatus: React.FC<ReceiveStatusProps> = ({ received }) => {
  const { t } = useTranslation('fortune');
  return (
    <span
      className={css`
        display: inline-block;
        font-size: 10px;
        min-width: 68px;
        line-height: 1.2;
        text-align: center;
        border-radius: 4px;
        margin: 2px 0;
        padding: 4px 8px;
        color: ${received ? '#f5f1e3' : '#6e4b22'};
        background: ${received ? '#cdc7bb' : '#ffb342'};
      `}
    >
      {received ? t('have_received') : t('have_not_received')}
    </span>
  );
};
